export default __webpack_public_path__ + "static/media/teams.0f923554.png";